import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'antd';
import { classNames } from '../../utils';
import HorizontalScroll from '../HorizontalScroll/HorizontalScroll';

const OnboardingVideos = ({ links, text, className, inStore }) => {
  const videos = React.useMemo(() =>
    links.map((vid) => {
      return (
        <Col
          className={`OnboardingPanel_videoCol${inStore ? ' inStore' : ''}`}
          key={`video-${vid.id}`}
        >
          <iframe
            key={vid.id}
            className="OnboardingPanel_video"
            src={`https://www.youtube-nocookie.com/embed/${vid.id}${
              vid.start ? `?start=${vid.start}` : '/'
            }`}
            // srcDoc={`<style>*{padding:0;margin:0;overflow:hidden}html,body{height:100%}img,span{position:absolute;width:100%;top:0;bottom:0;margin:auto}span{height:1.5em;text-align:center;font:48px/1.5 sans-serif;color:white;text-shadow:0 0 0.5em black}</style><a href=https://www.youtube.com/embed/${vid.id}?autoplay=1><img src=https://img.youtube.com/vi/${vid.id}/hqdefault.jpg alt='Video TheHost.Co ${vid.title}'><span>▶</span></a>`}
            title={vid.title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </Col>
      );
    }),
  );

  return (
    <div className={classNames(className, 'OnboardingPanel_videosContainer')}>
      <div className="OnboardingPanel_title">{text.title}</div>
      <p className="OnboardingPanel_videosContainer copy">{text.copy}</p>
      <div className="OnboardingPanel_videosRow">
        <HorizontalScroll items={videos} />
      </div>
    </div>
  );
};

OnboardingVideos.propTypes = {
  links: PropTypes.array,
  text: PropTypes.object,
  className: PropTypes.string,
  inStore: PropTypes.bool,
};

export default OnboardingVideos;
